import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';

export const graviteeApiOperatorBuilderPlugin = createPlugin({
  id: 'gravitee-api-operator-builder',
  routes: {
    root: rootRouteRef,
  },
});

export const GraviteeApiOperatorBuilderPage = graviteeApiOperatorBuilderPlugin.provide(
  createRoutableExtension({
    name: 'GraviteeApiOperatorBuilderPage',
    mountPoint: rootRouteRef,
    component: () =>
      import('./components/GraviteeApiOperatorBuilderPage').then(
        m => m.GraviteeApiOperatorBuilderPage,
      ),
  }),
);
